import { configureStore } from "@reduxjs/toolkit";
import levelReducer from "./levelSlice";
import deviceReducer from "./deviceSlice";

export const store = configureStore({
  reducer: {
    level: levelReducer,
    device: deviceReducer,
  },
});
